import store from '../../store';
import router from '@/router';
import { stopTimeWorker } from '@/workers';

export default class AgentLogoffForcedEvent {
  constructor(body) {
    console.log('Informações logoff forçado: ', body);
    stopTimeWorker();
    store.dispatch('attendance/disconnectClient', null, {
      root: true,
    });
    store.dispatch('auth/deleteToken');
    store.dispatch('resetState');
    store.dispatch('showSnackbar', { text: 'disconnectedBySystem' });
    router.push('/login');
  }
}
